module.exports = __webpack_public_path__ + "static/img/cookie.3aa28efc.svg";